<ng-template let-data="data">
  <div
    class="fx-popover-panel mat-elevation-z5"
    [id]="panelId"
    [ngClass]="classList"
    tabindex="-1"
    role="menu"
    (mouseenter)="setMouseState(true)"
    (mouseleave)="setMouseState(false)"
    cdkTrapFocus
    #panel
  >
    <div class="fx-popover-content">
      <ng-container *ngIf="popoverContent?.templateRef">
        <ng-container *ngTemplateOutlet="popoverContent.templateRef; context:{data: data}"></ng-container>
      </ng-container>
      <ng-content></ng-content>
    </div>
    <div class="fx-popover-arrow"></div>
  </div>
</ng-template>